import { Environment } from '@dice/app/types/env.type';
import { DEV_ENV_CONFIG } from '@dice/environments/dev/dev.env';
import { NgxLoggerLevel } from 'ngx-logger';

export const DEV_2_ENV_CONFIG: Environment = {
  ...DEV_ENV_CONFIG,
  hostNames: ['dice-dev-2.dev-scapp-corp.swisscom.com', 'localhost:3002'],
  enableDebugInfo: true,
  isProduction: false,
  variant: 'dice-ui-dev-2',
  logLevel: NgxLoggerLevel.DEBUG,
  budaStatusURL: 'https://dice-dev-2.dev-scapp-corp.swisscom.com/status',
};
